import React from 'react'
import {
	ReasonConditionBlock,
	ReasonConditionTitle,
	ReasonConditionItem,
} from './style'
import { LoaderSpinner } from 'components/Loader'

const ReclamationReasonCondition = React.forwardRef(
	(
		{
			title,
			items = [],
			onClickAction = () => {
				console.log('click ')
			},
			defaultValue = '',
			type = '',
			isHighlighted = false,
			isLoading,
			itemIndex,
			orderItemId,
		},
		ref
	) => (
		<ReasonConditionBlock ref={ref} isHighlighted={isHighlighted}>
			<ReasonConditionTitle isHighlighted={isHighlighted}>
				{title}
			</ReasonConditionTitle>
			{!!isLoading && <LoaderSpinner isActive={isLoading} />}
			{!!!isLoading &&
				items?.map((item, key) => {
					return (
						<ReasonConditionItem
							isActive={
								item?.props?.defaultMessage === defaultValue
							}
							key={key}
							onClick={() => {
								if (onClickAction)
									onClickAction(
										item,
										type,
										itemIndex,
										orderItemId
									)
							}}
						>
							{item}
						</ReasonConditionItem>
					)
				})}
		</ReasonConditionBlock>
	)
)

export default ReclamationReasonCondition
